module.exports = __webpack_public_path__ + "img/fourth-onboarding.079688da.png";